(() => {
  const SELECTOR_BAR = 'announcement-bar[data-slide-delay]';
  const SELECTOR_TRACK = '.announcement__slider';
  const SELECTOR_SLIDE = '.announcement__text';

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAnnouncementBar(bar) {
    const track = bar.querySelector(SELECTOR_TRACK);
    if (!track) return;

    const slides = Array.from(track.querySelectorAll(SELECTOR_SLIDE));
    if (slides.length <= 1) return;

    // Reset (au cas où init plusieurs fois: theme editor / section reload)
    cleanupAnnouncementBar(bar);

    track.classList.add('is-slider-ready');

    let index = 0;
    let timer = null;

    const delayAttr = bar.getAttribute('data-slide-delay');
    const delay = Math.max(parseInt(delayAttr, 10) || 7000, 1000);

    const setActive = (nextIndex) => {
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === nextIndex);
        if (i === nextIndex) {
          s.removeAttribute('aria-hidden');
        } else {
          s.setAttribute('aria-hidden', 'true');
        }
      });
      index = nextIndex;
    };

    const next = () => setActive((index + 1) % slides.length);

    const start = () => {
      if (prefersReducedMotion()) return;
      stop();
      timer = window.setInterval(next, delay);
      bar.__announcementTimer = timer;
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
      bar.__announcementTimer = null;
    };

    // Activer la 1ère slide
    setActive(0);
    start();

    // Pause au hover/focus (desktop & accessibilité)
    const onEnter = () => stop();
    const onLeave = () => start();
    bar.addEventListener('mouseenter', onEnter);
    bar.addEventListener('mouseleave', onLeave);
    bar.addEventListener('focusin', onEnter);
    bar.addEventListener('focusout', onLeave);

    // Stocker pour cleanup
    bar.__announcementCleanup = () => {
      stop();
      bar.removeEventListener('mouseenter', onEnter);
      bar.removeEventListener('mouseleave', onLeave);
      bar.removeEventListener('focusin', onEnter);
      bar.removeEventListener('focusout', onLeave);
      track.classList.remove('is-slider-ready');
      slides.forEach((s) => {
        s.classList.remove('is-active');
        s.removeAttribute('aria-hidden');
      });
    };
  }

  function cleanupAnnouncementBar(bar) {
    if (bar && typeof bar.__announcementCleanup === 'function') {
      bar.__announcementCleanup();
      bar.__announcementCleanup = null;
    }
    if (bar && bar.__announcementTimer) {
      window.clearInterval(bar.__announcementTimer);
      bar.__announcementTimer = null;
    }
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR_BAR).forEach(initAnnouncementBar);
  }

  // Init normal
  document.addEventListener('DOMContentLoaded', () => initAll());

  // Shopify theme editor: section reload
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(SELECTOR_BAR).forEach(cleanupAnnouncementBar);
  });
})();
